export const SortOptions = [
    '타이틀순',
    '학점순',
    '난이도순',
];